<template>
  <el-dropdown trigger="click" @command="handleExport">
    <el-button class="daochu-btn" :style="{width: btnWidth || '114px'}">
      <svg-icon icon-class="daochu" />
      &nbsp;{{title}}
      <div class="daochu-right">
        <!-- <span>...</span> -->
        <svg-icon icon-class="more" class-name="icon-common g-pointer" />
      </div>
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="1">{{menu1 || '导出选中数据'}}</el-dropdown-item>
      <el-dropdown-item command="2">{{menu2 || '全部导出'}}</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: '导出'
    },
    params: {
      type: Object,
      default() {
        return {}
      }
    },
    // 当前选中接口API
    btnWidth: {
      type: String,
      default: ''
    },
    // 当前选中接口API
    chooseApi: {
      type: String,
      default: ''
    },
    // 当前选中数据
    chooseIds: {
      type: String,
      default: ''
    },
    // 查询API
    searchApi: {
      type: String,
      default: ''
    },
    // 当前查询结果
    searchList: {
      type: Array,
      default() {
        return []
      }
    },
    menu1: {
      type: String,
      default: ''
    },
    menu2: {
      type: String,
      default: ''
    }
  },
  watch: {
    chooseIds(newVal) {
      this.chooseDataIds = newVal
    },
    searchList(newVal) {
      this.searchDataList = newVal
    },
  },
  data() {
    return {
      chooseDataIds: this.chooseIds,
      searchDataList: this.searchList
    }
  },
  methods: {
    handleExport(type) {
      if (type === '1') {
        if (!this.chooseDataIds) {
          this.$message.warning('请选择要导出的数据')
          return
        }
        location.href = '/singleMuseum' + this.chooseApi + this.chooseDataIds
        this.$emit('clearSelectsCall') // 清空选中状态
      } else if (type === '2') {
        if (this.searchApi) {
          let obj = "", keys
          if (this.params) {
            keys = Object.keys(this.params)
            keys.forEach((item, index) => {
              if (index == 0) {
                if(this.params[item]){
                  obj += `${item}=${this.params[item]}`

                }
              } else {
                if(this.params[item]){
                  obj += `&${item}=${this.params[item]}`

                }

              }
            })
          }
          if(obj){
            location.href = '/singleMuseum' + this.searchApi + '?' + obj
          }else{
            location.href = '/singleMuseum' + this.searchApi
          }
          // location.href = '/singleMuseum' + this.searchApi
        } else {
          location.href = '/singleMuseum' + this.chooseApi

        }
        // console.log('查询', this.searchApi)
        // let apiArr = []
        // let pre = this.searchApi.split('?')[0] + '?'
        // let strArr = this.searchApi.split('?')[1].split('&')
        // strArr.forEach(item => {
        //   let arr = item.split('=')
        //   if (arr[1] === 'null' || arr[1] === 'undefined') {
        //     item = arr[0] + '='
        //     apiArr.push(arr[0] + '=')
        //   } else {
        //     apiArr.push(item)
        //   }
        // })
        // console.log(pre + apiArr.join('&'))
        // location.href = '/singleMuseum' + pre + apiArr.join('&')
        // location.href = '/singleMuseum' + this.searchApi
      }
    }
  }
}
</script>


<style lang="scss" scoped>
.daochu-btn {
  position: relative;
  text-align: left;
  width: 114px;
  border: 1px solid $primary;
  color: $primary;
  .daochu-right {
    display: block;
    position: absolute;
    width: 35px;
    height: 39px;
    font-weight: bold;
    line-height: 30px;
    text-align: center;
    top: 0;
    border-left: 1px solid $primary;
    right: 0;
    .icon-common {
      position: relative;
      top: 7px;
      font-size: 18px;
      color: $primary;
    }
  }
}
</style>

